import React from "react";
import {IonFooter, IonIcon, IonLabel, IonSegment, IonSegmentButton} from "@ionic/react";

import styles from './NavFooter.module.css';

interface Tab {
  tab: string;
  icon: any;
  label: string;
}

interface Props {
  value: string;
  onChange: (tab:string) => void;
  tabs: Tab[];
}

export const NavFooter: React.FC<Props> = (props) => (
  <IonFooter>
    <IonSegment
      value={props.value}
      onIonChange={(e:any) => props.onChange(e.detail.value)}
      color="secondary"
    >
      {
        props.tabs.map(t => (
          <IonSegmentButton
            value={t.tab} key={t.tab}
            className={styles.navButton}
          >
            <IonIcon icon={t.icon}/>
            <IonLabel className="font-condensed text-xs">
              {t.label}
            </IonLabel>
          </IonSegmentButton>
        ))
      }
    </IonSegment>
  </IonFooter>
);
